module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0131.jpg?v=f99ae461";